import { INCREMENT, DECREMENT } from '../actions/counter';
import { OPEN, OPEN_WITH_ID, CLOSE } from '../actions/modal';
import { SHOW_MAIN_TEXT, HIDE_MAIN_TEXT } from '../actions/layout';
import { MUSIC_PLAY, MUSIC_PAUSE, LANG_DE, LANG_EN, LANG_RU } from '../actions/nav';
import { ENABLE_ANALYTICS, DISABLE_ANALYTICS, ENABLE_ALL_COOKIES, DISABLE_ALL_COOKIES, SHOW_SETTINGS, HIDE_SETTINGS } from '../actions/cookieconsent';
import { PORTFOLIO_ID } from '../actions/portfolio';
import { SCREEN_RESIZE } from '../actions/ui';

/* Does not work with combinereducer so far */
const initialState = {
  count: 0,
  modalVisible: false,
  requestClose: false,
  music: false,
  lang: 'en',
  pf_id: 'default', //0 for no project id
  img_id: 0,
  screenWidth: typeof window === 'object' ? window.innerWidth : 1024,
  screenHeight: typeof window === 'object' ? window.innerHeight : 768,
  cookies_all: false,
  cookies_analytics: false,
  showSettings: false,
  showMainT: false
}

export default function reducer(state=initialState , action) {
  /* DEBUG */
  //console.log(action.type);

  switch (action.type) {
  case INCREMENT:
    return Object.assign({}, state, {
      count: state.count + 1
    });
  case DECREMENT:
    return Object.assign({}, state, {
      count: state.count - 1
    });
  /* Modal */
  case OPEN:
    return Object.assign({}, state, {
      modalVisible: true
    });
  case OPEN_WITH_ID:
    return Object.assign({}, state, {
      modalVisible: true,
      pf_id: action.payload,
      img_id: action.img_id
    });
  case CLOSE:
    return Object.assign({}, state, {
      modalVisible: false
    });
  /* LANG */
  case LANG_DE:
    return Object.assign({}, state, {
      lang: 'de'
    });
  case LANG_EN:
    return Object.assign({}, state, {
      lang: 'en'
    });
  case LANG_RU:
    return Object.assign({}, state, {
      lang: 'ru'
    });
  /* MUSIC */
  case MUSIC_PLAY:
    return Object.assign({}, state, {
      music: true
    });
  case  MUSIC_PAUSE:
    return Object.assign({}, state, {
      music: false
    });
  /* LAYOUT */
  case  SHOW_MAIN_TEXT:
    return Object.assign({}, state, {
      showMainT: true
    });
    case  HIDE_MAIN_TEXT:
      return Object.assign({}, state, {
        showMainT: false
      });
  /* PORTFOLIO */
  case  PORTFOLIO_ID:
    return Object.assign({}, state, {
      pf_id: action.payload
    });
    case SCREEN_RESIZE:
            return Object.assign({}, state, {
                screenWidth: action.screenWidth,
                screenHeight: action.screenHeight
    });
    /* COOKIE CONSENT */
    case  DISABLE_ANALYTICS:
          return Object.assign({}, state, {
          cookies_analytics: false
      });
      case  ENABLE_ANALYTICS:
            return Object.assign({}, state, {
            cookies_analytics: true
        });
      case  DISABLE_ALL_COOKIES:
            return Object.assign({}, state, {
            cookies_all: false
      });
      case  ENABLE_ALL_COOKIES:
            return Object.assign({}, state, {
            cookies_all: true
            });
      case  SHOW_SETTINGS:
            return Object.assign({}, state, {
            showSettings: true
            });
      case  HIDE_SETTINGS:
            return Object.assign({}, state, {
            showSettings: false
            });
  default:
    return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/index.js